import {
    Component,
    Inject,
    OnInit,
    Optional,
    RESPONSE_INIT,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { DjangoService } from '@core/services/django.service';
import { EnvironmentService } from '@core/services/environment.service';
import { MetadataService } from '@core/services/metadata.service';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    imports: [RouterLink],
})
export class NotFoundComponent implements OnInit {
    constructor(
        private metadataService: MetadataService,
        private environmentService: EnvironmentService,
        private router: Router,
        private djangoService: DjangoService,
        @Optional() @Inject(RESPONSE_INIT) private response: ResponseInit
    ) {}

    ngOnInit(): void {
        this.metadataService.setTitle('Not Found!');
        if (this.environmentService.isServer()) {
            this.response.status = 404;
        } else {
            this.djangoService
                .countNotFound({
                    path: this.router.url,
                })
                .subscribe();
        }
    }
}
